import { AutoMap } from "@automapper/classes";
import { PermissionsDTO } from "./permissions.dto";

export class RoleDTO {
    @AutoMap()
    name?: string;
    @AutoMap()
    permissions: PermissionsDTO[] = [];
}